import { NavLink } from 'react-router-dom';
import { ExternalLinkIcon, LogOutIcon, ShieldAlertIcon, ShieldCheckIcon } from 'lucide-react';
import { useAdminUser } from '../../AdminContext';
import { adminSections } from '../../../data/adminSections';
import { ADMIN_BASE, shopHref } from '../../../utils/hosts';
type Props = {
  onLogout: () => void;
  showSiteLink?: boolean;
};

/** Wie er is ingelogd, je beveiliging (tweestaps), uitloggen, en (op de telefoon) de link naar de website. */
export function AdminAccount({
  onLogout,
  showSiteLink = false
}: Props) {
  const user = useAdminUser();
  const twoFactorOn = user.twoFactor.enabled;
  const Shield = twoFactorOn ? ShieldCheckIcon : ShieldAlertIcon;
  return <div className="border-t border-line p-3 pb-[max(0.75rem,env(safe-area-inset-bottom))]" data-id="element-5223" data-mp="1otznt2mcy89x">
      {showSiteLink && <a href={shopHref('/')} target="_blank" rel="noreferrer" className="mb-1 flex min-h-[48px] items-center gap-3 rounded-md px-3 text-[15px] text-muted transition-colors duration-150 ease-soft hover:text-ink" data-id="element-5224" data-mp="3e8xpsqc2zvd4">
          <ExternalLinkIcon className="h-4 w-4" strokeWidth={1.75} aria-hidden="true" data-id="element-5225" data-mp="p4qtc8ivkalt" />
          Bekijk de website
          <span className="sr-only" data-id="element-5226" data-mp="ywn0e92xvb26"> (opent in een nieuw tabblad)</span>
        </a>}
      <NavLink to={`${ADMIN_BASE}${adminSections.beveiliging.path}`} className={({
      isActive
    }) => `mb-1 flex min-h-[40px] items-center gap-3 rounded-md px-3 text-[14px] transition-colors duration-150 ease-soft ${isActive ? 'bg-white text-ink shadow-sm ring-1 ring-line' : 'text-muted hover:bg-white/60 hover:text-ink'}`} data-id="element-5227" data-mp="txtk68w9p5yb">
        <Shield className={`h-4 w-4 shrink-0 ${twoFactorOn ? 'text-sage' : 'text-clay'}`} strokeWidth={1.75} aria-hidden="true" data-id="element-5228" data-mp="g42dr9du226t" />
        <span className="min-w-0 flex-1 truncate" data-id="element-5229" data-mp="1rl2b4jf1f77p">{adminSections.beveiliging.label}</span>
        <span className={`shrink-0 text-[12px] ${twoFactorOn ? 'text-muted' : 'text-clay'}`} data-id="element-5230" data-mp="1mmr0w7ktyuoy">{twoFactorOn ? 'Tweestaps aan' : 'Tweestaps uit'}</span>
      </NavLink>
      <div className="flex items-center gap-3 rounded-md px-3 py-2" data-id="element-5231" data-mp="1up9hl3m1sqf4">
        <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-clay text-[13px] text-shell" aria-hidden="true" data-id="element-5232" data-mp="1yngz40oc5vrd">
          {user.name.charAt(0)}
        </span>
        <span className="min-w-0 flex-1" data-id="element-5233" data-mp="28lwre6z3nb2g">
          <span className="block truncate text-[14px] text-ink" data-id="element-5234" data-mp="28kvdzvum2chk">{user.name}</span>
          <span className="block truncate text-[12px] text-muted" data-id="element-5235" data-mp="1b10s51bw2yjb">{user.email}</span>
        </span>
        <button type="button" onClick={onLogout} aria-label="Uitloggen" className="flex h-11 w-11 items-center justify-center rounded-md text-muted transition-colors duration-150 ease-soft hover:bg-white hover:text-ink" data-id="element-5236" data-mp="1fyk57xwup59o">
          <LogOutIcon className="h-4 w-4" strokeWidth={1.75} aria-hidden="true" data-id="element-5237" data-mp="s7oihf79509a" />
        </button>
      </div>
    </div>;
}